export const PARAMS = {
  contactDetails: {
    contactId: 'contactId',
  },
  editContact: {
    contactId: 'contactId',
  },
  editTag: {
    tagId: 'tagId',
  },
  passwordReset: {
    token: 'token',
  },
  tagList: {},
  tagDetails: {
    tagId: 'tagId',
  },
  verifyEmail: {
    token: 'token',
  },
}
